import LoginView from '@/views/default/LoginView.vue'
import AccessManagementView from '@/views/default/AccessManagementView.vue'

const routes = [
  {
    path: '*',
    redirect: {
      name: 'access-management'
    }
  },
  {
    name: 'login',
    path: '/login',
    component: LoginView
  },
  {
    name: 'access-management',
    path: '/access-management',
    component: AccessManagementView,
    meta: {
      requiresAuth: true
    }
  }
]

export default routes
